import './landing.css';
import Header from './components/Header';
import Banner from './components/Banner';
import Rest from './components/Rest';

const LandingPage = () => {
    return (
        <>
            <body className='home page-template page-template-page-home page-template-page-home-php page page-id-26 custom-background'>
                <div id='page' className='site'>
                    <a className='skip-link screen-reader-text' href='#content'>Skip to content</a>
                    <Header />
                    <Banner />
                    <Rest />
                </div>
            </body>
        </>
    );
}

export default LandingPage;
